<template>
  <Modal :isOpen="!!component" :title="title" @onClose="handleClose">
    <component :is="component" @onClose="handleClose" v-bind="props" />
  </Modal>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import Modal from '@/components/Modal/Modal.vue';

export default {
  data() {
    return {
      component: null,
      title: '',
      props: null,
    };
  },
  created() {
    EventBus.$on('modal', ({ component, title = '', props = null }) => {
      this.component = component;
      this.title = title;
      this.props = props;
    });
  },
  methods: {
    handleClose() {
      this.component = null;
    },
  },
  components: { Modal },
};
</script>
